import { useState } from 'react'

type Props = {
  className?: string
  text: string
  width?: number
}

export function Tooltip({ className, text, width }: Props) {
  const [tooltipVisible, showToolTip] = useState(false)

  const style = {
    display: tooltipVisible ? 'block' : 'none',
    width: width || 250,
  }

  const containerClassName = className
    ? `tooltip-container ${className}`
    : 'tooltip-container'

  return (
    <div className={containerClassName}>
      <button
        type="button"
        className="tooltip-icon-button"
        onMouseOver={() => showToolTip(true)}
        onMouseOut={() => showToolTip(false)}
      >
        i
      </button>
      <div className="tooltip" style={style}>
        {text}
      </div>
    </div>
  )
}
